module.exports = __webpack_public_path__ + "img/bus.0eda19a6.svg";